import React from 'react';
import { Badge, Box, Heading } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone/react';
import s from './Title.scss';

export function Title() {
  const { t } = useTranslation();

  return (
    <>
      <Heading size="extraLarge" className={s.landingTitle} textAlign="center">
        {t('devibe.onboarding.title')}
      </Heading>
      <Box className={s.alphaBadge}>
        <Badge uppercase={false} skin="neutral" size="small">
          ALPHA
        </Badge>
      </Box>
    </>
  );
}
